import { Vue, Component, Prop } from "vue-property-decorator";
import NewsOverview from "./news-overview";
// import { router } from "../../global";

declare global {
    interface Window {
        mgnlContextPath: string;
    }
}

@Component
export default class NewsTeaser extends Vue {
    @Prop({ type: String, default: "" })
    public categories!: string;

    private categoriesArray: string[] = [];
    public isOpen = false;
    private newsOverview = this.$parent as NewsOverview;

    public mounted() {
        this.categoriesArray = this.categories.split(",");
        this.newsOverview = this.$parent as NewsOverview;
        this.newsOverview.addObserver(this);
        this.update();
    }

    public update() {
        const currentCategory = this.newsOverview.currentCategory;
        this.isOpen = this.categoriesArray.includes(currentCategory) || currentCategory === "";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/scripts/news-teaser.ts